import React from 'react';

import { Dialog } from '@mui/material';
import { FileDown } from 'lucide-react';

import Button from '../../common/Button';

type DownloadTemplatesDialogProps = {
  trigger?: {
    label?: React.ReactNode;
    style?: React.CSSProperties;
  };
  children: React.ReactNode;
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

type DownloadActualDataTemplatesDialogProps = {};

const DownloadTemplatesDialog = ({
  trigger,
  children,
  open,
  handleOpen,
  handleClose,
}: DownloadTemplatesDialogProps) => (
  <>
    <Button onClick={handleOpen} variant="outlined">
      <FileDown size={20} />
      {trigger?.label ?? 'Download Template(s)'}
    </Button>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alertTitle"
      aria-describedby="alertContent"
    >
      <div className="flex flex-col gap-6 p-6">
        {children}
        <div className="flex justify-end gap-3">
          <Button
            onClick={handleClose}
            variant="outlined"
            tabIndex={3}
            style={{
              color: '#666',
              borderColor: '#B3B3B3',
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Dialog>
  </>
);

export default DownloadTemplatesDialog;
